
import { defineComponent, PropType } from 'vue'
import { Invoice } from '~/types/types'
import { formatDate, parseISODate } from '~/utils/date'
export default defineComponent({
  name: 'BillingUI2Invoices',
  props: {
    invoices: {
      type: Array as PropType<Invoice[]>,
      default: () => []
    }
  },
  methods: {
    formatDate,
    parseISODate
  }
})
